import type { AudioTrack } from "../types/schema";

/**
 * Calculate total duration from audio tracks.
 * All tracks MUST have durationInSeconds provided.
 *
 * @param audioTracks - Array of audio tracks to calculate duration from
 * @returns Total duration in seconds
 */
export function calculateTotalDuration(audioTracks: AudioTrack[]): number {
	return audioTracks.reduce((sum, track) => sum + track.durationInSeconds, 0);
}
